import Text from "../../../../Components/Text"
import Button from "../../../../Components/Buttons/Button"
import { useNavigate } from "react-router-dom";
import Subscribe from "../../../../APIController/Subscribe"
import SubscriptionInfo from "../../../../Components/SubscriptionInfo";
import SubscriptionTable from "../../../../Components/SubcriptionTable";
import { useEffect, useState } from "react";
import { getWorkspace } from "../../../../Model/Workspace";

const EditSubscriptionForm = ({ afterAction }) => {
    const navigate = useNavigate();
    const { cancelSubscription } = Subscribe()
    const [workspace, setWorkspace] = useState(null)
      useEffect(()=>{
        async function saveWorkspace(){
          const data = await getWorkspace()
          setWorkspace(data)
        }
        saveWorkspace()
      },[])
    const subscription = workspace?.subscription;
    const isTester = workspace?.freeTester;


    const handleCancelSubscription = async (e) => {
        e.preventDefault();
        const confirmDelete = window.confirm("Bist du sicher, dass das Abo zu diesem Workspace beenden willst?");
        if (!confirmDelete) return;
        await cancelSubscription();
        navigate("/app");
    }

    const SubscriptionCard = () => (
        <div className="flex bg-white flex-col border-2 rounded-lg gap-4 p-4 hover:border-blue-500 transition-colors shadow-md hover:shadow-lg">
            <div className="flex flex-col gap-2">
                <Text type="subtitle" classNames="text-center">
                    {subscription.name}
                </Text>
                <Text type="maintitle" classNames="text-center text-blue-600">
                    {subscription.price} CHF
                </Text>
                <Text type="itemtext" classNames="text-center min-h-[40px]">
                    {subscription.description}
                </Text>
            </div>
            <div className="flex flex-col gap-2 pt-2 border-t">
                <Text type="itemtext" classNames="text-center min-h-[40px]">
                    Für Features und Vergleiche siehe Tabelle
                </Text>
            </div>
        </div>
    );


    return (
        <div className="w-full h-full flex flex-col">
            <Text type="maintitle" classNames={"w-full flex text-start"} >Abo verwalten</Text>
            {isTester && (
                <div className="w-full flex flex-col gap-2 px-5 py-2">
                    <Text type="maintitle" classNames={"w-full flex text-start"} >Du bist ein Gratis Tester</Text>

                    <div flex flex-col mt-5>
                        <Text type="buttontext" classNames={"w-full flex text-start"} >Als Tester hast du alle Funktionen, sowohl veröffentlichte als auch Beta Funktionen.</Text>
                        <Text type="buttontext" classNames={"w-full flex text-start"} >Für diesen Zugeng zahlst du keine Monatlichen Gebühren.</Text>
                        <Text type="itemtext" classNames={"w-full flex text-start mt-5"} >Bei allfälligen Bugs kannst du uns unter: </Text>
                        <a
                            href="mailto:raycraftstudios.ch@gmail.com?subject=Cashier%20One%20Support"
                            className="hover:underline"
                        >
                            <Text type="itemtext" classNames={"w-full flex text-start hover:underline"} >raycraftstudios.ch@gmail.com </Text>
                        </a>
                        <Text type="itemtext" classNames={"w-full flex text-start"} >erreichen </Text>
                    </div>
                </div>
            )}
            {!isTester && subscription && (
                <div className="w-full flex flex-col gap-2 px-5 py-2">
                    <Text type="maintitle" classNames={"w-full flex text-start"} >{`Aktuelles Abo Modell: ${subscription.name}`}</Text>
                    <SubscriptionCard />
                    <SubscriptionTable />
                    <Button
                        text={"Abo Kündigen"}
                        buttonColor="bg-red-500"
                        classNames="w-full"
                        onClickAction={handleCancelSubscription}
                    />
                </div>
            )}
            {!isTester && !subscription && (
                <div className="w-full px-5 py-2">
                    <SubscriptionInfo direction="flex flex-col gap-4 w-full justify-center" />
                    <SubscriptionTable />
                </div>
            )}
        </div>
    )
}

export default EditSubscriptionForm